export default {
  'components.empty.desc.default': '暂无数据',
  'components.empty.desc.error': '通用错误',
  'components.empty.desc.search': '未搜索到内容',
  'components.empty.desc.car': '购物车为空',
  'components.empty.desc.order': '暂无订单记录',
  'components.empty.desc.coupon': '还没有优惠券',
  'components.empty.desc.collect': '还没有任何收藏',
  'components.empty.desc.address': '没有收货地址',
  'components.empty.desc.notification': '暂无通知',
  'components.empty.desc.nodata': '暂无内容',
};
